import { useQuery } from "@tanstack/react-query";
import { emailsApi } from "@/api/emails";
import { AuditTrailView } from "../AuditTrailView";
interface Props {
  emailId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
export default function AuditTrailModal({
  emailId,
  open,
  onOpenChange,
}: Props) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["audit-trail", emailId],
    queryFn: () => emailsApi.getAuditTrail(emailId),
    enabled: open && !!emailId,
  });
  return (
    <AuditTrailView
      key={emailId}
      open={open}
      onOpenChange={onOpenChange}
      title="Audit Trail"
      subtitle={data?.email_subject}
      logs={data?.logs || []}
      loading={isLoading}
      error={!!error}
      onRetry={() => {
        void refetch();
      }}
    />
  );
}
